import colors from './colors.js';
import CompletedIcon from '../assests/green.png';
import ActiveIcon from '../assests/active.svg';
import PendingIcon from '../assests/pending.svg';
import GrayColorStatusIcon from '../assests/grayIcon.svg';
import BlueColorStatusIcon from '../assests/blueIcon.svg';
import RejectIcon from '../assests/reject.svg';
import RedIcon from '../assests/Red.svg';

export const STORAGE_KEYS = {
  AUTH_INFO: 'MPOWERED_AUTH_INFO',
  AUTH_TOKEN: 'MPOWERED_AUTH_TOKEN',
  REALM_INFO: 'MPOWERED_REALM_INFO',
  WELCOME_BACK: 'WELCOME_BACK',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
};

export const numberRegex = /^\d+$/;

const bold = (
  <p style={{ fontSize: '14px', fontWeight: '400' }}>
    Please click on the link below to download the{' '}
    <span style={{ fontWeight: '600' }}>price list file.</span>
  </p>
);

export const ACTIVE_PRICE_LIST_PAGE = {
  PriceListTitle: 'Price list coming soon!',
  PriceListText:
    'Please come back later while we bring the coverage price list to you.',
  DownloadTitle: 'Download price list',
  DownloadText: bold,
  DownloadDescription:
    'Machine Readable Files (MRFs) are a requirement of the Transparency in Coverage (TiC) regulations. The files contain negotiated rates for in-network providers and allowed amounts derived from historical claims for out-of-network providers. Each network is responsible for sharing this information and they maintain their files. The MRFs are intended for researchers, regulators, and application developers to access and more easily analyze this information. BAC is working to make the data within the MRFs more user friendly as the files are much too large for typical office or home computing environments. In the meantime, the files are available at the link below. Please proceed with caution before attempting to download.',
  DownloadWarning:
    'WARNING! The files contained in the links are extremely large, as large as one Terabyte (TB), which has significant system requirements for use. Please ensure you have the required memory capacity, hardware, and software capabilities before attempting to download.',
};

export const DATA_SOURCE = {
  'Apple Health': 'https://www.apple.com/ios/health/',
  'My Medicare': ['https://www.cms.gov/', 'bluebutton.cms.gov'],
};

export const LABELS = {
  SIGNUP: {
    MEMBER_DETAILS: 'Member Details',
  },
};

export const NUMBER_OF_ROWS_PER_PAGE = 10;

export const CONDITION_CLINICAL_STATUS_LIST = [
  'active',
  'recurrence',
  'relapse',
  'inactive',
  'remission',
  'resolved',
];

export const CLAIMS_STATUS_LIST = ['active', 'cancelled', 'draft', 'others'];

export const BILLS_STATUS_LIST = [
  'draft',
  'issued',
  'balanced',
  'cancelled',
  'Entered In Error',
];

export const PRIOR_AUTH_STATUS_LIST = ['active', 'completed', 'others'];

export const COVERAGE_STATUS_LIST = ['active', 'draft', 'cancelled', 'others'];

export const NOTIFICATION_ALERT_MENU_ITEMS = [
  'Bills',
  'Care Plans',
  'Appointments',
  'Assessments',
];

export const FETCH_STATUS_BY_NAME = {
  active: 'Active',
  inactive: 'Inactive',
  expired: 'Expired',
  resolved: 'Resolved',
  all: 'All',
  completed: 'Completed',
  others: 'Others',
  cancelled: 'Cancelled',
  draft: 'Draft',
  final: 'Final',
  lab: 'Lab',
  radiology: 'Radiology',
  'on-hold': 'On Hold',
  revoked: 'Revoked',
  unknown: 'Unknown',
  'not-done': 'Not Done',
  preparation: 'Preparation',
  'in-progress': 'In Progress',
  'all visits': 'All',
  'Virtual Visit': 'Virtual Visit',
  'In Clinic Visit': 'In Clinic Visit',
  proposed: 'Proposed',
  booked: 'Booked',
  fulfilled: 'Fulfilled',
  noshow: 'No Show',
  'checked-in': 'Checked In',
  pending: 'Pending',
  arrived: 'Arrived',

  enteredInError: 'Entered In Error',
  waitlist: 'Waitlisted',
  planned: 'Planned',
  finished: 'Finished',
  ambulatory: 'AMB',
  emergency: 'EMER',
  field: 'FLD',
  'home health': 'HH',
  'inpatient encounter': 'IMP',
  'inpatient acute': 'ACUTE',
  'inpatient non-acute': 'NONAC',
  'observation encounter': 'OBSENC',
  'pre-admission': 'PRENC',
  'short stay': 'SS',
  virtual: 'VR',
  registered: 'Registered',
  partial: 'Partial',
  preliminary: 'Preliminary',
  issued: 'Issued',
  balanced: 'Balanced',
  'entered-in-error': 'Entered In Error',
  suspended: 'Suspended',
};

export const PHONE_NO_START_ADORNMENT = '+1';

export const PHONE_VERIFICATION_TEXTS = Object.freeze({
  TITLE: 'Enter the OTP to secure account',
  BODY: ' Please enter a 4 digit otp sent to',
  NO_RECEIVE: `Didn't recieve the OTP?`,
  OPT_SENT: 'Verification Code Sent',
  OPT_RESENT: 'Resend OTP',
  EDIT_PHONE_NO: 'Edit Phone number',
  VERIFY: 'Verify',
  WRONG_OTP: 'Verification code doesn’t match',
  PHONE_NUMBER: 'Phone Number',
  VERIFY_OTP_TEXT: 'Otp verified successfully!',
  BTN_TEXT_RESEND: 'Resend',
  BTN_TEXT_RESEND_OTP: 'Resend OTP',
  PHONE_VERIFICATION_STATUS: {
    APPROVED: 'approved',
    PENDING: 'pending',
    EXPIRED: 'expired',
    DENIED: 'denied',
  },
});
export const GET_DOCUMENTS_TYPE_BY_CODE = {
  '87520-3': 'Coverage',
  '11450-4': 'Conditions',
  '26436-6': 'Lab Results',
  '56445-0': 'Medications',
  '11369-6': 'Immunizations',
  '8716-3': 'Vitals',
  '47042-7': 'Allergies',
  '52031-2': 'Claims',
  '47039-3': 'Visits',
  '34122-2': 'Procedure',
};
export const PHONE_VERIFICATION_SUCCESS_TEXTS = Object.freeze({
  PHONE_VERIFIED: 'Code Verified',
  PHONE_VERIFIED_MSG: 'Your phone number has been verified successfully',
  AWESOME: 'Awesome!',
  GO_TO_DASHBOARD: '  Go to Dashboard',
  PHONE_VERIFICATION_STATUS: {
    APPROVED: 'approved',
    PENDING: 'pending',
    EXPIRED: 'expired',
    DENIED: 'denied',
  },
});

export const DRAWER_WIDTH = 320;
export const DRAWER_WIDTH_MOBILE = 240;

export const DEFAULT_GLOBAL_CONFIG = Object.freeze({
  carousel: {
    logo: 'https://member-portal-resources.s3.amazonaws.com/affiliate1/bcbsLogo.png',
    topRightColor: '#036FCB',
    bottomLeftColor: '#00A0DF',
    bottomRightColor: '#3C9DEB',
    carousel_content: [
      {
        title: 'Find Care & Schedule Visits \n with best providers',
        description:
          'Now you can easily schedule virtual or in clinic visits with trusted providers of your choice',
        urls: 'https://member-portal-resources.s3.amazonaws.com/affiliate1/GroupImg1.svg ',
      },
      {
        title: 'Pay your bills in just one click',
        description:
          'Now you can easily schedule virtual or in clinic visits with trusted providers of your choice',
        urls: 'https://member-portal-resources.s3.amazonaws.com/affiliate1/GroupImg2.svg ',
      },
      {
        title: 'Track all your medical records',
        description:
          'You can choose any type of service and view the details related to that services',
        urls: 'https://member-portal-resources.s3.amazonaws.com/affiliate1/GroupImg3.svg',
      },
    ],
  },
  user_registration_fields: [
    {
      placeholder: 'For example 123456789',
      title: 'Group Number',
      type: 'text',
      name: 'groupnumber',
      helperText: null,
      helperImage: true,
      helperImageText: 'Find your Group ID ?',
      helperImageUrl:
        'https://financialcontrol.in/wp-content/uploads/2019/06/Bajaj-Finserv-EMI-Card-Review-e1561049356264.png',
    },
    {
      placeholder: 'Enter first name',
      title: 'First Name',
      type: 'text',
      name: 'firstname',
      helperText: null,
      helperImage: 'none',
      helperImageText: null,
      helperImageUrl: null,
    },
    {
      placeholder: 'Enter last name',
      title: 'Last Name',
      type: 'text',
      name: 'lastname',
      helperText: 'Do not include suffixes, i.e Jr, Sr, etc.',
      helperImage: 'none',
      helperImageText: null,
      helperImageUrl: null,
    },
    {
      placeholder: 'Enter Date of Birth',
      title: 'Date of Birth',
      type: 'date',
      name: 'date',
      helperText: null,
      helperImage: 'none',
      helperImageText: null,
      helperImageUrl: null,
    },
    {
      placeholder: 'Enter SSN/ITIN',
      title: 'SSN/ITIN',
      type: 'text',
      name: 'ssn',
      helperText: null,
      helperImage: true,
      helperImageText: 'Find your SSN/ITIN ?',
      helperImageUrl:
        'https://financialcontrol.in/wp-content/uploads/2019/06/Bajaj-Finserv-EMI-Card-Review-e1561049356264.png',
    },
  ],
});

export const FORGOT_PASSWORD = Object.freeze({
  TITLE: 'Forgot Password',
  TEXT: 'Enter a 4 digit code sent to',
  RESEND_OTP: 'Resend OTP',
  PHONE_NO_EDIT_TEXT: 'Edit Phone number',
  NO_RECEIVE_OTP: `Didn't recieve it?`,
});

export const Content_Title = Object.freeze({
  Title: 'Terms And Conditions',
  Description:
    'The following outlines the Terms & Conditions of use of the Mpowered Health application. Before using any of the Mpowered Health services, you are requested to read, understand and agree to these terms.',
  PrivacyPolicy: 'Privacy Policy',
  PrivacyPolicyDescription:
    'The following outlines the Privacy Policy for the use of the Mpowered Health application. Before using any of the Mpowered Health services, you are requested to read, understand and agree to these terms.',
});

export const FIXED_DASHBOARD_SERVICES = [
  'Assessments',
  'Care Plans',
  'Appointments',
  'Bills',
];
export const FIXED_MEDICAL_SERVICES = {
  title: 'Medical',
  services: ['Allergies', 'Conditions', 'Immunizations'],
};

export const FIXED_FINANCIAL_SERVICES = {
  title: 'Financial',
  services: ['Bills', 'Claims', 'Coverage and benefits'],
};
export const FIXED_CARE_SERVICES = {
  title: 'Care',
  services: ['Care Plans', 'Find Care', 'Care Team'],
};
export const FIXED_LEGAL_SERVICES = {
  title: 'Legal',
  services: ['Consents', 'Advance Directive'],
};

export const NOTIFICATION_OBJECT = {
  Assessments: 'You have a health risk assessment to complete',
  'Care Plans': 'You have a diabetes care plan to complete',
  Appointments: 'You have an upcoming dental appointment with Dr. Smith',
  Bills: 'You have bills that are now due',
};

export const NOTIFICATION_CATEGORY = {
  Assessments: '4 hr ago ~ Assessments',
  'Care Plans': '1 hr ago ~ Care Plans',
  Appointments: '2 hr ago ~ Appointments',
  Bills: '15 min ago ~ Bills',
};

export const formatStatus = value => {
  if (!value) {
    return value;
  }
  return value.replaceAll('-', ' ').replaceAll('_', ' ');
};
const STATUS_LIST = {
  ALL: 'All',
  Completed: 'Completed',
  RECCURENCE: 'Recurrence',
  RELAPSED: 'Relapse',
  INCompleted: 'InCompleted',
  REMISSION: 'Remission',
  RESOLVED: 'Resolved',
  CANCELLED: 'Cancelled',
  DRAFT: 'Draft',
  ENTERED_ERROR: 'Entered In Error',
  PREPRATION: 'Preparation',
  IN_PROGRESS: 'In Progress',
  NOT_DONE: 'Not Done',
  ON_HOLD: 'On Hold',
  STOPPED: 'Stopped',
  COMPLETED: 'Completed',
  REGISTERED: 'Registered',
  PARTIAL: 'Partial',
  PRELIMINARY: 'Preliminary',
  FINAL: 'Final',
  AMMENDED: 'Amended',
  PLANNED: 'Planned',
  ARRIVED: 'Arrived',
  TRIAGED: 'Triaged',
  ON_LEAVE: 'On Leave',
  FINSISHED: 'Finished',
  UNKNOWN: 'Unknown',
  OTHERS: 'Others',
  DUE: 'Due',
  PAST_DUE: 'Past Due',
  PAID: 'Paid',
  ISSUED: 'Issued',
  BALANCED: 'Balanced',
  CORRECTED: 'Corrected',
  SUCCESSFUL: 'Successful',
  APPENDED: 'Appended',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  REVOKED: 'Revoked',
  PROPOSED: 'Proposed',
  BOOKED: 'Booked',
  FULFILLED: 'Fulfilled',
  NOSHOW: 'Noshow',
  ENTEREDINERROR: 'Entered-in-error',
  CHECKEDIN: 'Checked In',
  WAITLIST: 'Waitlist',
  SUSPENDED: 'Suspended',
  EXPIRED: 'Expired',
};

export const STATUS_COLOR_LIST = [
  {
    key: STATUS_LIST.RECCURENCE,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.RELAPSED,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.INCompleted,
    color: colors.CRIMSON,
  },
  {
    key: STATUS_LIST.REMISSION,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.RESOLVED,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.CANCELLED,
    color: colors.CRIMSON,
  },
  {
    key: STATUS_LIST.DRAFT,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.ENTERED_ERROR,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.PREPRATION,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.IN_PROGRESS,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.ACTIVE,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.NOT_DONE,
    color: colors.CRIMSON,
  },
  {
    key: STATUS_LIST.ON_HOLD,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.STOPPED,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.COMPLETED,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.REGISTERED,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.PARTIAL,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.PRELIMINARY,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.FINAL,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.AMMENDED,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.PLANNED,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.ARRIVED,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.ON_LEAVE,
    color: colors.CRIMSON,
  },
  {
    key: STATUS_LIST.FINSISHED,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.TRIAGED,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.OTHERS,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.DUE,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.PAST_DUE,
    color: colors.ORANGE,
  },
  {
    key: STATUS_LIST.PAID,
    color: colors.GREEN,
  },
  {
    key: STATUS_LIST.ISSUED,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.BALANCED,
    color: colors.GREEN_G700,
  },
  {
    key: STATUS_LIST.UNKNOWN,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.SUSPENDED,
    color: colors.RED,
  },
  { key: STATUS_LIST.EXPIRED, color: colors.RED },
  {
    key: STATUS_LIST.CORRECTED,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.SUCCESSFUL,
    color: colors.GREEN,
  },
  {
    key: STATUS_LIST.APPENDED,
    color: colors.GREEN,
  },
  {
    key: STATUS_LIST.ACTIVE,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.INACTIVE,
    color: colors.CRIMSON,
  },
  {
    key: STATUS_LIST.PENDING,
    color: colors.YELLOW,
  },
  {
    key: STATUS_LIST.REVOKED,
    color: colors.CRIMSON,
  },
  {
    key: STATUS_LIST.PROPOSED,
    color: colors.YELLOW,
  },
  {
    key: STATUS_LIST.BOOKED,
    color: colors.GREEN,
  },
  {
    key: STATUS_LIST.FULFILLED,
    color: colors.GREEN,
  },
  {
    key: STATUS_LIST.NOSHOW,
    color: colors.GREY,
  },
  {
    key: STATUS_LIST.CHECKEDIN,
    color: colors.BLUE,
  },
  {
    key: STATUS_LIST.WAITLIST,
    color: colors.YELLOW,
  },
];

export const DOSAGE_LIST_ITEMS = Object.freeze({
  NO_OF_PILLS: 'No. of pills',
  TIME: 'Time',
  COMMENTS: 'Comments',
});

export const DEFAULT_NULL_REPLACEMENT = '-';

export const VITAL_FHIR_CODES = {
  BODY_HEIGHT: '8302-2',
  BLOOD_PRESSURE: '55284-4',
  BODY_TEMPERATURE: '8310-5',
  BODY_WEIGHT: '29463-7',
  HEART_RATE: '8867-4',
  RESPIRATORY_RATE: '9279-1',
  BLOOD_PRESSURE_CHILDREN: '85354-9',
  // BLOOD_OXYGEN_LEVEL: '59408-5.',
  OXYGEN_SATURATION: '2708-6',
  VITAL_SIGNS_PANEL: '85353-1',
  HEAD_CIRCUMFERENCE: '9843-4',
  BODY_MASS_INDEX: '39156-5',
  SYSTOLIC_BLOOD_PRESSURE: '8480-6',
  DIASTOLIC_BLOOD_PRESSURE: '8462-4',
};

export const VITAL_TYPES = {
  BLOOD_PRESSURE: 'BLOOD_PRESSURE',
  BODY_TEMPERATURE: 'BODY_TEMPERATURE',
  HEART_RATE: 'HEART_RATE',
  BODY_HEIGHT: 'BODY_HEIGHT',
  BODY_WEIGHT: 'BODY_WEIGHT',
  RESPIRATORY_RATE: 'RESPIRATORY_RATE',
  BLOOD_PRESSURE_CHILDREN: 'BLOOD_PRESSURE',
  // BLOOD_OXYGEN_LEVEL: 'BLOOD_OXYGEN_LEVEL',
  OXYGEN_SATURATION: 'OXYGEN_SATURATION',
  VITAL_SIGNS_PANEL: 'VITAL_SIGNS_PANEL',
  HEAD_CIRCUMFERENCE: 'HEAD_CIRCUMFERENCE',
  BODY_MASS_INDEX: 'BODY_MASS_INDEX',
  SYSTOLIC_BLOOD_PRESSURE: 'SYSTOLIC_BLOOD_PRESSURE',
  DIASTOLIC_BLOOD_PRESSURE: 'DIASTOLIC_BLOOD_PRESSURE',
};

export const VITAL_TYPE_DROPDOWN_ITEMS = [
  {
    value: 'ALL',
    label: 'All',
  },
  {
    value: VITAL_TYPES.BODY_TEMPERATURE,
    label: 'Body temperature',
  },
  {
    value: VITAL_TYPES.BLOOD_PRESSURE,
    label: 'Blood pressure',
  },
  //{
  //value: VITAL_TYPES.BLOOD_PRESSURE_CHILDREN,
  //label: 'Blood pressure children',
  //},
  {
    value: VITAL_TYPES.HEART_RATE,
    label: 'Heart rate',
  },
  {
    value: VITAL_TYPES.BODY_HEIGHT,
    label: 'Height',
  },
  {
    value: VITAL_TYPES.BODY_WEIGHT,
    label: 'Weight',
  },
  {
    value: VITAL_TYPES.RESPIRATORY_RATE,
    label: 'Respiratory rate',
  },
  {
    value: VITAL_TYPES.OXYGEN_SATURATION,
    label: 'Oxygen saturation',
  },
  {
    value: VITAL_TYPES.VITAL_SIGNS_PANEL,
    label: 'Vital signs panel',
  },
  {
    value: VITAL_TYPES.HEAD_CIRCUMFERENCE,
    label: 'Head circumference',
  },
  {
    value: VITAL_TYPES.BODY_MASS_INDEX,
    label: 'Body mass index',
  },
  {
    value: VITAL_TYPES.SYSTOLIC_BLOOD_PRESSURE,
    label: 'Systolic blood pressure',
  },
  {
    value: VITAL_TYPES.DIASTOLIC_BLOOD_PRESSURE,
    label: 'Diastolic blood pressure',
  },
  {
    value: 'others',
    label: 'Others',
  },
];

export const VITAL_REVERSE_LOOKUP_CODES = {
  [VITAL_FHIR_CODES.BODY_HEIGHT]: VITAL_TYPES.BODY_HEIGHT,
  [VITAL_FHIR_CODES.BLOOD_PRESSURE]: VITAL_TYPES.BLOOD_PRESSURE,
  [VITAL_FHIR_CODES.BODY_TEMPERATURE]: VITAL_TYPES.BODY_TEMPERATURE,
  [VITAL_FHIR_CODES.BODY_WEIGHT]: VITAL_TYPES.BODY_WEIGHT,
  [VITAL_FHIR_CODES.HEART_RATE]: VITAL_TYPES.HEART_RATE,
  [VITAL_FHIR_CODES.RESPIRATORY_RATE]: VITAL_TYPES.RESPIRATORY_RATE,
  [VITAL_FHIR_CODES.BLOOD_PRESSURE_CHILDREN]:
    VITAL_TYPES.BLOOD_PRESSURE_CHILDREN,
  // [VITAL_FHIR_CODES.BLOOD_OXYGEN_LEVEL]: VITAL_TYPES.BLOOD_OXYGEN_LEVEL,
  [VITAL_FHIR_CODES.OXYGEN_SATURATION]: VITAL_TYPES.OXYGEN_SATURATION,
  [VITAL_FHIR_CODES.VITAL_SIGNS_PANEL]: VITAL_TYPES.VITAL_SIGNS_PANEL,
  [VITAL_FHIR_CODES.HEAD_CIRCUMFERENCE]: VITAL_TYPES.HEAD_CIRCUMFERENCE,
  [VITAL_FHIR_CODES.BODY_MASS_INDEX]: VITAL_TYPES.BODY_MASS_INDEX,
  [VITAL_FHIR_CODES.SYSTOLIC_BLOOD_PRESSURE]:
    VITAL_TYPES.SYSTOLIC_BLOOD_PRESSURE,
  [VITAL_FHIR_CODES.DIASTOLIC_BLOOD_PRESSURE]:
    VITAL_TYPES.DIASTOLIC_BLOOD_PRESSURE,
};

export const VITALS_LABELS = {
  [VITAL_TYPES.BODY_HEIGHT]: 'Body Height',
  [VITAL_TYPES.BLOOD_PRESSURE]: 'Blood Pressure',
  [VITAL_TYPES.BODY_TEMPERATURE]: 'Body Temperature',
  [VITAL_TYPES.BODY_WEIGHT]: 'Body Weight',
  [VITAL_TYPES.HEART_RATE]: 'Heart Rate',
  [VITAL_TYPES.RESPIRATORY_RATE]: 'Respiratory Rate',
  [VITAL_TYPES.BLOOD_PRESSURE_CHILDREN]: 'Blood Pressure',
  // [VITAL_TYPES.BLOOD_OXYGEN_LEVEL] : 'Blood Oxygen Level',
  [VITAL_TYPES.OXYGEN_SATURATION]: 'Oxygen Saturation',
  [VITAL_TYPES.VITAL_SIGNS_PANEL]: 'Vitals Signs Panel',
  [VITAL_TYPES.HEAD_CIRCUMFERENCE]: 'Head Circumference',
  [VITAL_TYPES.BODY_MASS_INDEX]: 'Body Mass Index',
  [VITAL_TYPES.SYSTOLIC_BLOOD_PRESSURE]: 'Systolic Blood Pressure',
  [VITAL_TYPES.DIASTOLIC_BLOOD_PRESSURE]: 'Diastolic Blood Pressure',
  ALL_DATA: 'All Data',
};

export const DATE_FORMAT = '<MMM> <DD>, <YYYY>';

export const DEFAULT_BP_VALUE = 'N.A';

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const labResultsStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['registered'],
    value: 'registered',
    icon: ActiveIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['partial'],
    value: 'partial',
    icon: PendingIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['preliminary'],
    value: 'preliminary',
    icon: PendingIcon,
  },
  { label: FETCH_STATUS_BY_NAME['final'], value: 'final', icon: CompletedIcon },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const billsStatusFilterMenuItems = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['draft'], value: 'draft', icon: PendingIcon },
  { label: FETCH_STATUS_BY_NAME['issued'], value: 'issued', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['balanced'],
    value: 'balanced',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['cancelled'],
    value: 'cancelled',
    icon: RejectIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['Entered In Error'],
    value: 'Entered In Error',
    icon: GrayColorStatusIcon,
  },
];

export const alltypesdocuments = [
  { label: 'All', value: 'all' },
  { label: 'Lab Results', value: 'Lab Results' },
  { label: 'Conditions', value: 'Conditions' },
  { label: 'Coverage', value: 'Coverage' },
  { label: 'Medications', value: 'Medications' },
  { label: 'Immunizations', value: 'Immunizations' },
  { label: 'Vitals', value: 'Vitals' },
  { label: 'Allergies', value: 'Allergies' },
  { label: 'Claims', value: 'Claims' },
  { label: 'Visits', value: 'Visits' },
  { label: 'Procedure', value: 'Procedure' },
];
export const visitsStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['planned'],
    value: 'planned',
    icon: PendingIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['in-progress'],
    value: 'in-progress',
    icon: BlueColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['arrived'],
    value: 'arrived',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['finished'],
    value: 'finished',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const VISIT_STATUS_LIST = [
  'planned',
  'in-progress',
  'arrived',
  'finished',
  'others',
];

export const VISIT_TYPES = [
  { label: FETCH_STATUS_BY_NAME['all visits'], value: 'all visits' },
  { label: FETCH_STATUS_BY_NAME['ambulatory'], value: 'ambulatory' },
  { label: FETCH_STATUS_BY_NAME['emergency'], value: 'emergency' },
  { label: FETCH_STATUS_BY_NAME['field'], value: 'field' },
  { label: FETCH_STATUS_BY_NAME['home health'], value: 'home health' },
  {
    label: FETCH_STATUS_BY_NAME['inpatient encounter'],
    value: 'inpatient encounter',
  },
  { label: FETCH_STATUS_BY_NAME['inpatient acute'], value: 'inpatient acute' },
  {
    label: FETCH_STATUS_BY_NAME['inpatient non-acute'],
    value: 'inpatient non-acute',
  },
  {
    label: FETCH_STATUS_BY_NAME['observation encounter'],
    value: 'observation encounter',
  },
  { label: FETCH_STATUS_BY_NAME['pre-admission'], value: 'pre-admission' },
  { label: FETCH_STATUS_BY_NAME['short stay'], value: 'short stay' },
  { label: FETCH_STATUS_BY_NAME['virtual'], value: 'virtual' },
];

export const APPOINTMENT_TYPES = [
  { label: FETCH_STATUS_BY_NAME['all visits'], value: 'all visits' },
  { label: FETCH_STATUS_BY_NAME['Virtual Visit'], value: 'Virtual Visit' },
  { label: FETCH_STATUS_BY_NAME['In Clinic Visit'], value: 'In Clinic Visit' },
];

export const AppointmentStatusFilterData = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['proposed'],
    value: 'proposed',
    icon: PendingIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['booked'],
    value: 'booked',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['fulfilled'],
    value: 'fulfilled',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['noshow'],
    value: 'noshow',
    icon: GrayColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['checked-in'],
    value: 'checked-in',
    icon: BlueColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['pending'],
    value: 'pending',
    icon: PendingIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['arrived'],
    value: 'arrived',
    icon: CompletedIcon,
  },

  {
    label: FETCH_STATUS_BY_NAME['entered-in-error'],
    value: 'entered-in-error',
    icon: GrayColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['waitlist'],
    value: 'waitlist',
    icon: PendingIcon,
  },
];

export const ConsentTypes = {
  'Privacy Consent': 'Consent to Share',
  Treatment: 'Consent for Treatment',
  Research: 'Consent to Research',
};

export const consentMapping = {
  'Privacy Consent': 'Share',
  'Treatment ': 'Treatment',
};

export const ALLERGIES_STATUS_LIST = ['active', 'inactive', 'resolved]'];

export const allergiesStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['inactive'],
    value: 'inactive',
    icon: RejectIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['resolved'],
    value: 'resolved',
    icon: CompletedIcon,
  },
];

export const PROCEDURES_STATUS_LIST = [
  'preparation',
  'in-progress',
  'not-done',
  'completed',
  'others',
];

export const proceduresStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['preparation'],
    value: 'preparation',
    icon: ActiveIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['in-progress'],
    value: 'in-progress',
    icon: ActiveIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['not-done'],
    value: 'not-done',
    icon: RejectIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['completed'],
    value: 'completed',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const dateFilterMenuItems = [
  { label: 'All', value: 'all' },
  { label: 'Past 1 Month', value: '1 month' },
  { label: 'Past 3 Months', value: '3 months' },
  { label: 'Past 6 Months', value: '6 months' },
];

export const MEDICATIONS_STATUS_LIST = ['active', 'inactive', 'others'];

export const medicationsStatusFilterMenuItems = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['inactive'],
    value: 'inactive',
    icon: RejectIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const dateFilterData = [
  { label: 'All', value: 'all' },
  { label: 'Past 1 Month', value: '1 month' },
  { label: 'Past 3 Months', value: '3 months' },
  { label: 'Past 6 Months', value: '6 months' },
];

export const immunizationsStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['not-done'],
    value: 'not-done',
    icon: RejectIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['completed'],
    value: 'completed',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['enteredInError'],
    value: 'entered-in-error',
    icon: GrayColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];
export const stepsForMedicalHistory = [
  'Visit Details',
  'Pick a date & time',
  'Medical History',
  'Payment',
];
export const diagnosisDropDownConstatnt = [
  [
    'Once a day',
    'Twice a day',
    'Thrice a day',
    'Four times a day',
    '5+ times a day',
  ],
  ['Yes', 'No'],
];
export const findCareMedicalHistoryData = [
  {
    data: 'Do you smoke ?',
    id: '0',
    frequency: [
      '1-5 Cigarettes per day',
      '6-10 Cigarettes per day',
      '11-20 Cigarettes per day',
      '21+ Cigarettes per day',
      "Don't know",
      'No Answer',
    ],
  },
  {
    data: 'Do you drink alchohol ?',
    id: '1',
    frequency: [
      '1-2 drinks per day',
      '3-5 drinks per day',
      '5-10 drinks per day',
      '10+ drinks per day',
      "Don't know",
      'No Answer',
    ],
  },
  {
    data: 'Are you into recreational drugs ?',
    id: '2',
    frequency: [
      'Daily several times per day',
      'Most days ',
      'Just on weekends',
      'Only occasionally ',
      'Rarely (few times a year)',
      "Don't know",
      'No Answer',
    ],
  },
];

export const careplansStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['draft'], value: 'draft', icon: PendingIcon },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['on-hold'],
    value: 'on-hold',
    icon: GrayColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['completed'],
    value: 'completed',
    icon: CompletedIcon,
  },
  { label: FETCH_STATUS_BY_NAME['revoked'], value: 'revoked', icon: RedIcon },
  {
    label: FETCH_STATUS_BY_NAME['entered-in-error'],
    value: 'entered-in-error',
    icon: GrayColorStatusIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['unknown'],
    value: 'unknown',
    icon: GrayColorStatusIcon,
  },
];

export const assessmentsStatusFilterData = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['completed'],
    value: 'COMPLETED',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['pending'],
    value: 'DRAFT',
    icon: PendingIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['expired'],
    value: 'EXPIRED',
    icon: RedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['in-progress'],
    value: 'IN-PROGRESS',
    icon: ActiveIcon,
  },
];

export const ASSESSMENT_LISTING_MSG = {
  ASSESSMENT_NOT_FOUND: {
    title: 'Assessment not found',
    helperMsg:
      'The assessment you are trying to search can not be found. Please look for another assessment',
    iconURL:
      'https://mpowered-assets.s3.us-east-2.amazonaws.com/SearchIcon.svg',
  },
};

export const careTeamsStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  {
    label: FETCH_STATUS_BY_NAME['proposed'],
    value: 'proposed',
    icon: PendingIcon,
  },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['suspended'],
    value: 'suspended',
    icon: RedIcon,
  },
  { label: FETCH_STATUS_BY_NAME['inactive'], value: 'inactive', icon: RedIcon },

  {
    label: FETCH_STATUS_BY_NAME['entered-in-error'],
    value: 'entered-in-error',
    icon: GrayColorStatusIcon,
  },
];

export const conditionsStatusFilterMenuItems = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  { label: FETCH_STATUS_BY_NAME['inactive'], value: 'inactive', icon: RedIcon },
  {
    label: FETCH_STATUS_BY_NAME['resolved'],
    value: 'resolved',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const coverageStatusFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  { label: FETCH_STATUS_BY_NAME['draft'], value: 'draft', icon: PendingIcon },
  {
    label: FETCH_STATUS_BY_NAME['cancelled'],
    value: 'cancelled',
    icon: RedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const documentTypeFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['lab'], value: 'lab' },
  { label: FETCH_STATUS_BY_NAME['radiology'], value: 'radiology' },
  { label: FETCH_STATUS_BY_NAME['others'], value: 'others' },
];

export const SMOKING_STATUS_LIST = ['final', 'others'];

export const smokingStatusFilterDatas = [
  { label: 'All', value: 'all' },
  { label: FETCH_STATUS_BY_NAME['final'], value: 'final', icon: CompletedIcon },
  {
    label: FETCH_STATUS_BY_NAME['registered'],
    value: 'registered',
    icon: ActiveIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['preliminary'],
    value: 'preliminary',
    icon: PendingIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const ClaimsStatusFilteredData = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['cancelled'],
    value: 'cancelled',
    icon: RejectIcon,
  },
  { label: FETCH_STATUS_BY_NAME['draft'], value: 'draft', icon: PendingIcon },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const priorAuthorizationFilterDatas = [
  { label: FETCH_STATUS_BY_NAME['all'], value: 'all' },
  { label: FETCH_STATUS_BY_NAME['active'], value: 'active', icon: ActiveIcon },
  {
    label: FETCH_STATUS_BY_NAME['completed'],
    value: 'completed',
    icon: CompletedIcon,
  },
  {
    label: FETCH_STATUS_BY_NAME['others'],
    value: 'others',
    icon: GrayColorStatusIcon,
  },
];

export const consentFilterMenuItems = [
  { label: 'All', value: 'all' },
  { label: 'CONSENT TO SHARE', value: 'CONSENT TO SHARE' },
  { label: 'CONSENT FOR TREATMENT', value: 'CONSENT FOR TREATMENT' },
  { label: 'CONSENT TO RESEARCH', value: 'CONSENT TO RESEARCH' },
];

export const CMS_CLAIMS_TYPE_TEXTS = {
  All: 'All',
  CARRIER: 'Professional Services',
  DME: 'Durable Medical Equipment',
  HHA: 'Home Health Services',
  HOSPICE: 'Hospice',
  INPATIENT: 'Inpatient',
  OUTPATIENT: 'Outpatient',
  PDE: 'Prescription Drugs',
  SNF: 'Skilled Nursing Facility',
  oral: 'Oral',
  pharmacy: 'Pharmacy',
  vision: 'Vision',
  institutional: 'Institutional Services',
  professional: 'Professional Services',
};

export const claimTypeFilterMenuItems = [
  {
    value: 'all',
    label: CMS_CLAIMS_TYPE_TEXTS['All'],
  },
  {
    value: 'CARRIER',
    label: CMS_CLAIMS_TYPE_TEXTS['CARRIER'],
  },
  {
    value: 'DME',
    label: CMS_CLAIMS_TYPE_TEXTS['DME'],
  },
  {
    value: 'HHA',
    label: CMS_CLAIMS_TYPE_TEXTS['HHA'],
  },
  {
    value: 'HOSPICE',
    label: CMS_CLAIMS_TYPE_TEXTS['HOSPICE'],
  },
  {
    value: 'INPATIENT',
    label: CMS_CLAIMS_TYPE_TEXTS['INPATIENT'],
  },
  {
    value: 'OUTPATIENT',
    label: CMS_CLAIMS_TYPE_TEXTS['OUTPATIENT'],
  },
  {
    value: 'PDE',
    label: CMS_CLAIMS_TYPE_TEXTS['PDE'],
  },
  {
    value: 'SNF',
    label: CMS_CLAIMS_TYPE_TEXTS['SNF'],
  },
  {
    value: 'institutional',
    label: CMS_CLAIMS_TYPE_TEXTS['institutional'],
  },
  {
    value: 'pharmacy',
    label: CMS_CLAIMS_TYPE_TEXTS['pharmacy'],
  },
  {
    value: 'oral',
    label: CMS_CLAIMS_TYPE_TEXTS.oral,
  },
  {
    value: 'vision',
    label: CMS_CLAIMS_TYPE_TEXTS.vision,
  },
];

export const EOB_COST_LABELS = Object.freeze({
  institutionalCost: 'Institutional',
  pharmacyCost: 'Pharmacy',
  professionalCost: 'Professional',
  hhaCost: 'HHA',
  dmeCost: 'DME',
  visionCost: 'Vision',
  oralCost: 'Dental',
});

export const CLAIMS_DASHBOARD_TEXTS = Object.freeze({
  DUE: 'Your claims due',
  PATIENT: 'Patient Portion',
  INSURER: 'Insurer Portion',
  SUB_HEADER: 'Here is a helpful breakdown',
  LOADING_CLAIMS: 'Loading Claims',
  LOADING_CLAIM_DETAILS: 'Loading Claim Details',
  NO_RECORD: '0 records found',
  DROPDOWN_LABELS: {
    CLAIM: 'Select claim type',
    TP: 'Time period',
  },
  CLAIM_NUMBER: 'Claim number:',
  TAB_LABEL: ['Claims Summary', 'Claims'],
  SUMMARY: 'Claims Summary',
  TOTAL_AMOUNT: 'Total Claim Amount',
  COLLAPSE_TEXT: 'Click on collapse to hide breakup',
  COLLAPSE: 'Collapse',
  EXPAND_TEXT: 'Click on expand to view breakup',
  EXPAND: 'Expand',
});

export const CLAIMS = Object.freeze({
  TITLE: 'Claims',
  CARD_TITLE_PATIENT: 'Patient Portion:',
  CARD_TITLE_INSURER: 'Insurer Portion:',
});

export const PLAN_COVERAGE = Object.freeze({
  TITLE: 'Active Plans',
  CARD_TITLE_PATIENT: 'Patient Portion:',
  CARD_TITLE_INSURER: 'Insurer Portion:',
});

export const BILL_STATUS_PAY_MAPPING = {
  cancelled: 'Cancelled',
  enteredinerror: 'Cancelled',
  draft: 'Waiting for Confirmation',
  balanced: 'Paid',
  issued: 'Paid',
};

export const APPOINTMENT_EXTENSIONS = {
  VISIT_TYPE: 'Type_Of_Visit',
  SMOKING_VALUE: 'MedicationHistory_Smoking_Value',
  SMOKING_FREQUENCY: 'MedicationHistory_Smoking_Frequency',
  SMOKING_COMMENTS: 'MedicationHistory_Smoking_Comments',
  ALCOHOL_VALUE: 'MedicationHistory_Alcohol_Value',
  ALCOHOL_FREQUENCY: 'MedicationHistory_Alcohol_Frequency',
  ALCOHOL_COMMENTS: 'MedicationHistory_Alcohol_Comments',
  RECREATIONAL_VALUE: 'MedicationHistory_Recreational_Value',
  RECREATIONAL_FREQUENCY: 'MedicationHistory_Recreational_Frequency',
  RECREATIONAL_COMMENTS: 'MedicationHistory_Recreational_Comments',
};

export const morningTime = [
  {
    time: '9.00 AM',
    selected: 'none',
    actualTime: '09:00 AM',
  },
  {
    time: '9.30 AM',
    selected: 'none',
    actualTime: '09:30 AM',
  },
  {
    time: '10.00 AM',
    selected: 'none',
    actualTime: '10:00 AM',
  },
  {
    time: '10.30 AM',
    selected: 'none',
    actualTime: '10:30 AM',
  },
  {
    time: '11.00 AM',
    selected: 'none',
    actualTime: '11:00 AM',
  },
  {
    time: '11.30 AM',
    selected: 'none',
    actualTime: '11:30 AM',
  },
];
export const afternoonTime = [
  {
    id: '2929',
    status: 'BUSY',
    time: '09:00',
    timeStatus: 9,
  },
  {
    id: '2930',
    status: 'FREE',
    time: '01:00',
    timeStatus: 9,
  },
];
export const eveningTime = [
  {
    id: '2929',
    status: 'BUSY',
    time: '09:00',
    timeStatus: 9,
  },
  {
    id: '2930',
    status: 'FREE',
    time: '01:00',
    timeStatus: 9,
  },
];

export const APPOINTMENT_SCHEDULE_DETAILS = Object.freeze({
  HEADING: 'Visit rescheduled successfully!',
  CANCEL: 'Cancel Visit',
  QUESTION: 'Are you sure you want to cancel this visit?',
  DESCRIPTION:
    ' Your refund will be initiated just after the cancellation if you have made any payment. This may take upto 2 days to reflect refund balance in your account.',
});

export const DATE_FORMAT_APPOINTMENT = '<MMM> <DD> <YYYY>';

export const GENERIC_ERROR_MESSAGE = Object.freeze({
  TITLE: 'We’re Sorry...',
  SUBTITLE: `An error occur while loading the data please try refreshing the page or come back after some time.`,
  BAC_TOKEN_EXPIRY_MESSAGE:
    'Looks like your session has expired. Please login from the BACTPA portal again.',
});

export const IMMUNIZATION_STATUS_LIST = [
  'completed',
  'entered-in-error',
  'not-done',
];
